// extracted by mini-css-extract-plugin
export var cardLayout = "_2e-1";
export var paginationContainer = "_2e-0";